var _defs, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisiereProtectionElectrique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visi\\xE8re_de_protection_\\xE9lectrique",
    "data-name": "visi\\xE8re de protection \\xE9lectrique",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1082.68 1166.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2,.cls-8{fill:#bfbfbf;}.cls-3{stroke:#bfbfbf;stroke-miterlimit:10;stroke-width:4px;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#222;}.cls-6{fill:#0a0a0a;}.cls-7{fill:#5e5e5e;}.cls-8{opacity:0.26;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-537.32 -507.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600,967c3-7,1-11-19-13,11-25,12-79,10-86s-5-4-5-4V843c0-14-19-33-19-33s-5-3-29-3c-3.23-1.47-12.44-9.5-26.55-22-13.35-11.88-6.15-69.52-48.45-105-41-27-107-59-141-74-21-2-20-2-40.86-.82C1186.07,545.4,1077.76,498.28,980,509,749.82,532.43,653,743,653,743c-55,10-50,43-15,47l5,55c31,26,191,62,310,77,56,69,190,86,229,81-1,17,14,43,32,61,6,24,37,32,106,56s92,15,105,22,31,53,41,36,24-13,24-13c25.1,26.35,32.18,23.34,20-11,0,0,22-14,26-28,11,4,26,1,29-4s-25-32-25-32l1-16S1597,974,1600,967Zm-232-69s26,12,59,6c28,41,76,43,93,47,3,5-7,13-14,13s-84-20-95-36-21-15-34-19S1368,898,1368,898Zm103,128c-87,9-197-41-210-48s-7-72-17-87a57.79,57.79,0,0,0-17-16s45-1,89,11,21,28,33,40c42,41,149,66,178,62C1529,1019,1520,1021,1471,1026Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visi\xE8re de protection \xE9lectrique") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.86,788.68S490,1275,554,1640c-40-380,89-795,89-795S642,791,630.86,788.68Z",
    transform: "translate(-537.32 -507.47)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M933.73,919.44S879,1170,867,1282s-61,146-104,170-240,149-205,188,316,89,704-160c96-59,178-561,178-561",
    transform: "translate(-537.32 -507.47)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1600,967c3-7,1-11-19-13,11-25,12-79,10-86s-5-4-5-4V843c0-14-19-33-19-33s-5-3-29-3c-3.23-1.47-12.44-9.5-26.55-22-13.35-11.88-6.15-69.52-48.45-105-41-27-107-59-141-74-21-2-20-2-40.86-.82C1186.07,545.4,1077.76,498.28,980,509,749.82,532.43,653,743,653,743c-55,10-50,43-15,47l5,55c31,26,191,62,310,77,56,69,190,86,229,81-1,17,14,43,32,61,6,24,37,32,106,56s92,15,105,22,31,53,41,36,24-13,24-13c25.1,26.35,32.18,23.34,20-11,0,0,22-14,26-28,11,4,26,1,29-4s-25-32-25-32l1-16S1597,974,1600,967Zm-232-69s26,12,59,6c28,41,76,43,93,47,3,5-7,13-14,13s-84-20-95-36-21-15-34-19S1368,898,1368,898Zm103,128c-87,9-197-41-210-48s-7-72-17-87a57.79,57.79,0,0,0-17-16s45-1,89,11,21,28,33,40c42,41,149,66,178,62C1529,1019,1520,1021,1471,1026Z",
    transform: "translate(-537.32 -507.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M643,845s275-37,554,16c80,12,170,37,170,37l119,53h95s39-7,39,0-47,198-47,198l-94,86L651,859Z",
    transform: "translate(-537.32 -507.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "743.67 97.53 973.67 277.53 1016.67 233.53 930.67 134.53 775.67 71.53 743.67 97.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1538,807c-3.23-1.47-12.44-9.5-26.55-22C1498.1,773.08,1311,628,1281.14,605.18,1186.07,545.4,1077.76,498.28,980,509,1182,495,1417,722,1538,807Zm-170,91s26,12,59,6c28,41,76,43,93,47,3,5-7,13-14,13s-84-20-95-36-21-15-34-19S1368,898,1368,898Zm103,128c-87,9-197-41-210-48s-7-72-17-87a57.79,57.79,0,0,0-17-16s45-1,89,11,21,28,33,40c42,41,149,66,178,62C1529,1019,1520,1021,1471,1026Z",
    transform: "translate(-537.32 -507.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M638,789s-6-19,40-26,324-29,605,26l201,42-9,14s-294-82-611-73C691,771,638,789,638,789Z",
    transform: "translate(-537.32 -507.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M652,743s-6-19,40-26,324-29,605,26c201,42,206,56,206,56l-9,14s-299-96-616-87C705,725,652,743,652,743Z",
    transform: "translate(-537.32 -507.47)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M734,753s0,86-16,136-104,371-80,487c5,38,194.43,27.08,206.72-6.46S908.57,915.36,940,836c6-73,5-83,5-83C868.07,746.62,797.26,746.92,734,753Z",
    transform: "translate(-537.32 -507.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisiereProtectionElectrique);
export default __webpack_public_path__ + "static/media/visiere_protection_electrique.c914191bc9cade58dffaf70bfd326062.svg";
export { ForwardRef as ReactComponent };